import type { Campaign, Kpis } from "../lib/google-ads";
import { formatInt, formatMicros, formatPercent } from "../lib/format";

type Row = Campaign & { kpis: Kpis };

type CampaignTableProps = {
  rows: Row[];
  currency: string;
};

export function CampaignTable({ rows, currency }: CampaignTableProps) {
  if (rows.length === 0) {
    return (
      <div className="empty">
        <p>No campaigns yet — they'll appear here as soon as the first sync succeeds.</p>
      </div>
    );
  }

  const sorted = [...rows].sort((a, b) => b.kpis.costMicros - a.kpis.costMicros);

  return (
    <div className="table-wrap">
      <table className="campaign-table">
        <thead>
          <tr>
            <th>Campaign</th>
            <th>Status</th>
            <th>Type</th>
            <th className="num">Impr.</th>
            <th className="num">Clicks</th>
            <th className="num">CTR</th>
            <th className="num">Cost (30d)</th>
            <th className="num">Conv.</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((r) => (
            <tr key={r.id}>
              <td>{r.name}</td>
              <td><span className="status-pill" data-status={r.status.toLowerCase()}>{r.status}</span></td>
              <td className="muted">{r.advertising_channel_type ?? "—"}</td>
              <td className="num">{formatInt(r.kpis.impressions)}</td>
              <td className="num">{formatInt(r.kpis.clicks)}</td>
              <td className="num">{formatPercent(r.kpis.ctr)}</td>
              <td className="num">{formatMicros(r.kpis.costMicros, currency)}</td>
              <td className="num">{formatDecimal(r.kpis.conversions)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function formatDecimal(n: number): string {
  return n.toFixed(n < 10 ? 2 : 0);
}
